import { render, staticRenderFns } from "./ProfitabilityTable.vue?vue&type=template&id=1a6f9e44&"
import script from "./ProfitabilityTable.vue?vue&type=script&lang=js&"
export * from "./ProfitabilityTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports